export const masterData = [
    {
        "id": "title",
        "value": [
            { value: "mr", label: "Mr." },
            { value: "miss", label: "Miss" },
            { value: "mrs", label: "Mrs." },
            { value: "Ms", label: "Ms." },
        ]
    },
    {
        "id": "contactPreference",
        "value": [
            { value: "TELEPHONE", label: "Phone" },
            { value: "SMS", label: "SMS" },
            { value: "EMAIL_MY_MESSAGES", label: "Email" },
        ]
    },
    {
        "id": "dobDate",
        "value": [
            { value: "1", label: "1" },
            { value: "2", label: "2" },
            { value: "3", label: "3" },
            { value: "4", label: "4" },
            { value: "5", label: "5" },
            { value: "6", label: "6" },
            { value: "7", label: "7" },
            { value: "8", label: "8" },
            { value: "9", label: "9" },
            { value: "10", label: "10" },
            { value: "11", label: "11" },
            { value: "12", label: "12" },
            { value: "13", label: "13" },
            { value: "14", label: "14" },
            { value: "15", label: "15" },
            { value: "16", label: "16" },
            { value: "17", label: "17" },
            { value: "18", label: "18" },
            { value: "19", label: "19" },
            { value: "20", label: "20" },
            { value: "21", label: "21" },
            { value: "22", label: "22" },
            { value: "23", label: "23" },
            { value: "24", label: "24" },
            { value: "25", label: "25" },
            { value: "26", label: "26" },
            { value: "27", label: "27" },
            { value: "28", label: "28" },
            { value: "29", label: "29" },
            { value: "30", label: "30" },
            { value: "31", label: "31" },
        ]
    },
    {
        "id": "dobMonth",
        "value": [
            { value: "1", label: "01" },
            { value: "2", label: "02" },
            { value: "3", label: "03" },
            { value: "4", label: "04" },
            { value: "5", label: "05" },
            { value: "6", label: "06" },
            { value: "7", label: "07" },
            { value: "8", label: "08" },
            { value: "9", label: "09" },
            { value: "10", label: "10" },
            { value: "11", label: "11" },
            { value: "12", label: "12" },
        ]
    },
    {
        "id": "nationality",
        "value": [
            { value: "Ireland", label: "Ireland" },
            { value: "Afghanistan", label: "Afghanistan" },
            { value: "Aland Islands", label: "Aland Islands" },
            { value: "Albania", label: "Albania" },
            { value: "Algeria", label: "Algeria" },
            { value: "American Samoa", label: "American Samoa" },
            { value: "Andorra", label: "Andorra" },
            { value: "Angola", label: "Angola" },
            { value: "Anguilla", label: "Anguilla" },
            { value: "Antarctica", label: "Antarctica" },
            { value: "Antigua And Barbuda", label: "Antigua And Barbuda" },
            { value: "Argentina", label: "Argentina" },
            { value: "Armenia", label: "Armenia" },
            { value: "Aruba", label: "Aruba" },
            { value: "Australia", label: "Australia" },
            { value: "Austria", label: "Austria" },
            { value: "Azerbaijan", label: "Azerbaijan" },
            { value: "Bahamas", label: "Bahamas" },
            { value: "Bahrain", label: "Bahrain" },
            { value: "Bangladesh", label: "Bangladesh" },
            { value: "Barbados", label: "Barbados" },
            { value: "Belarus", label: "Belarus" },
            { value: "Belgium", label: "Belgium" },
            { value: "Belize", label: "Belize" },
            { value: "Benin", label: "Benin" },
            { value: "Bermuda", label: "Bermuda" },
            { value: "Bhutan", label: "Bhutan" },
            { value: "Bolivia", label: "Bolivia" },
            { value: "Bosnia And Herzegovina", label: "Bosnia And Herzegovina" },
            { value: "Botswana", label: "Botswana" },
            { value: "Bouvet Island", label: "Bouvet Island" },
            { value: "Brazil", label: "Brazil" },
            { value: "British Indian Ocean Territory", label: "British Indian Ocean Territory" },
            { value: "Brunei Darussalam", label: "Brunei Darussalam" },
            { value: "Bulgaria", label: "Bulgaria" },
            { value: "Burkina Faso", label: "Burkina Faso" },
            { value: "Burundi", label: "Burundi" },
            { value: "Cambodia", label: "Cambodia" },
            { value: "Cameroon", label: "Cameroon" },
            { value: "Canada", label: "Canada" },
            { value: "Cape Verde", label: "Cape Verde" },
            { value: "Cayman Islands", label: "Cayman Islands" },
            { value: "Central African Republic", label: "Central African Republic" },
            { value: "Chad", label: "Chad" },
            { value: "Chile", label: "Chile" },
            { value: "China", label: "China" },
            { value: "Christmas Island", label: "Christmas Island" },
            { value: "Cocos (Keeling) Islands", label: "Cocos (Keeling) Islands" },
            { value: "Colombia", label: "Colombia" },
            { value: "Comoros", label: "Comoros" },
            { value: "Congo", label: "Congo" },
            { value: "Congo, The Democratic Republic Of The", label: "Congo, The Democratic Republic Of The" },
            { value: "Cook Islands", label: "Cook Islands" },
            { value: "Costa Rica", label: "Costa Rica" },
            { value: "Cote DIvoire", label: "Cote DIvoire" },
            { value: "Croatia", label: "Croatia" },
            { value: "Cuba", label: "Cuba" },
            { value: "Cyprus", label: "Cyprus" },
            { value: "Czech Republic", label: "Czech Republic" },
            { value: "Denmark", label: "Denmark" },
            { value: "Djibouti", label: "Djibouti" },
            { value: "Dominica", label: "Dominica" },
            { value: "Dominican Republic", label: "Dominican Republic" },
            { value: "Ecuador", label: "Ecuador" },
            { value: "Egypt", label: "Egypt" },
            { value: "El Salvador", label: "El Salvador" },
            { value: "Equatorial Guinea", label: "Equatorial Guinea" },
            { value: "Eritrea", label: "Eritrea" },
            { value: "Estonia", label: "Estonia" },
            { value: "Ethiopia", label: "Ethiopia" },
            { value: "Falkland Islands (Malvinas)", label: "Falkland Islands (Malvinas)" },
            { value: "Faroe Islands", label: "Faroe Islands" },
            { value: "Fiji", label: "Fiji" },
            { value: "Finland", label: "Finland" },
            { value: "France", label: "France" },
            { value: "French Guiana", label: "French Guiana" },
            { value: "French Polynesia", label: "French Polynesia" },
            { value: "French Southern Territories", label: "French Southern Territories" },
            { value: "Gabon", label: "Gabon" },
            { value: "Gambia", label: "Gambia" },
            { value: "Georgia", label: "Georgia" },
            { value: "Germany", label: "Germany" },
            { value: "Ghana", label: "Ghana" },
            { value: "Gibraltar", label: "Gibraltar" },
            { value: "Greece", label: "Greece" },
            { value: "Greenland", label: "Greenland" },
            { value: "Grenada", label: "Grenada" },
            { value: "Guadeloupe", label: "Guadeloupe" },
            { value: "Guam", label: "Guam" },
            { value: "Guatemala", label: "Guatemala" },
            { value: "Guernsey", label: "Guernsey" },
            { value: "Guinea", label: "Guinea" },
            { value: "Guinea-Bissau", label: "Guinea-Bissau" },
            { value: "Guyana", label: "Guyana" },
            { value: "Haiti", label: "Haiti" },
            { value: "Heard Island And Mcdonald Islands", label: "Heard Island And Mcdonald Islands" },
            { value: "Holy See (Vatican City State)", label: "Holy See (Vatican City State)" },
            { value: "Honduras", label: "Honduras" },
            { value: "Hong Kong", label: "Hong Kong" },
            { value: "Hungary", label: "Hungary" },
            { value: "Iceland", label: "Iceland" },
            { value: "India", label: "India" },
            { value: "Indonesia", label: "Indonesia" },
            { value: "Iran, Islamic Republic Of", label: "Iran, Islamic Republic Of" },
            { value: "Iraq", label: "Iraq" },
            { value: "Isle Of Man", label: "Isle Of Man" },
            { value: "Israel", label: "Israel" },
            { value: "Italy", label: "Italy" },
            { value: "Jamaica", label: "Jamaica" },
            { value: "Japan", label: "Japan" },
            { value: "Jersey", label: "Jersey" },
            { value: "Jordan", label: "Jordan" },
            { value: "Kazakhstan", label: "Kazakhstan" },
            { value: "Kenya", label: "Kenya" },
            { value: "Kiribati", label: "Kiribati" },
            { value: "Korea, Democratic PeopleS Republic Of", label: "Korea, Democratic PeopleS Republic Of" },
            { value: "Korea, Republic Of", label: "Korea, Republic Of" },
            { value: "Kuwait", label: "Kuwait" },
            { value: "Kyrgyzstan", label: "Kyrgyzstan" },
            { value: "Lao PeopleS Democratic Republic", label: "Lao PeopleS Democratic Republic" },
            { value: "Latvia", label: "Latvia" },
            { value: "Lebanon", label: "Lebanon" },
            { value: "Lesotho", label: "Lesotho" },
            { value: "Liberia", label: "Liberia" },
            { value: "Libyan Arab Jamahiriya", label: "Libyan Arab Jamahiriya" },
            { value: "Liechtenstein", label: "Liechtenstein" },
            { value: "Lithuania", label: "Lithuania" },
            { value: "Luxembourg", label: "Luxembourg" },
            { value: "Macao", label: "Macao" },
            { value: "Macedonia, The Former Yugoslav Republic Of", label: "Macedonia, The Former Yugoslav Republic Of" },
            { value: "Madagascar", label: "Madagascar" },
            { value: "Malawi", label: "Malawi" },
            { value: "Malaysia", label: "Malaysia" },
            { value: "Maldives", label: "Maldives" },
            { value: "Mali", label: "Mali" },
            { value: "Malta", label: "Malta" },
            { value: "Marshall Islands", label: "Marshall Islands" },
            { value: "Martinique", label: "Martinique" },
            { value: "Mauritania", label: "Mauritania" },
            { value: "Mauritius", label: "Mauritius" },
            { value: "Mayotte", label: "Mayotte" },
            { value: "Mexico", label: "Mexico" },
            { value: "Micronesia, Federated States Of", label: "Micronesia, Federated States Of" },
            { value: "Moldova, Republic Of", label: "Moldova, Republic Of" },
            { value: "Monaco", label: "Monaco" },
            { value: "Mongolia", label: "Mongolia" },
            { value: "Montserrat", label: "Montserrat" },
            { value: "Morocco", label: "Morocco" },
            { value: "Mozambique", label: "Mozambique" },
            { value: "Myanmar", label: "Myanmar" },
            { value: "Namibia", label: "Namibia" },
            { value: "Nauru", label: "Nauru" },
            { value: "Nepal", label: "Nepal" },
            { value: "Netherlands", label: "Netherlands" },
            { value: "Netherlands Antilles", label: "Netherlands Antilles" },
            { value: "New Caledonia", label: "New Caledonia" },
            { value: "New Zealand", label: "New Zealand" },
            { value: "Nicaragua", label: "Nicaragua" },
            { value: "Niger", label: "Niger" },
            { value: "Nigeria", label: "Nigeria" },
            { value: "Niue", label: "Niue" },
            { value: "Norfolk Island", label: "Norfolk Island" },
            { value: "Northern Mariana Islands", label: "Northern Mariana Islands" },
            { value: "Norway", label: "Norway" },
            { value: "Oman", label: "Oman" },
            { value: "Pakistan", label: "Pakistan" },
            { value: "Palau", label: "Palau" },
            { value: "Palestinian Territory, Occupied", label: "Palestinian Territory, Occupied" },
            { value: "Panama", label: "Panama" },
            { value: "Papua New Guinea", label: "Papua New Guinea" },
            { value: "Paraguay", label: "Paraguay" },
            { value: "Peru", label: "Peru" },
            { value: "Philippines", label: "Philippines" },
            { value: "Pitcairn", label: "Pitcairn" },
            { value: "Poland", label: "Poland" },
            { value: "Portugal", label: "Portugal" },
            { value: "Puerto Rico", label: "Puerto Rico" },
            { value: "Qatar", label: "Qatar" },
            { value: "Reunion", label: "Reunion" },
            { value: "Romania", label: "Romania" },
            { value: "Russian Federation", label: "Russian Federation" },
            { value: "Rwanda", label: "Rwanda" },
            { value: "Saint Helena", label: "Saint Helena" },
            { value: "Saint Kitts And Nevis", label: "Saint Kitts And Nevis" },
            { value: "Saint Lucia", label: "Saint Lucia" },
            { value: "Saint Pierre And Miquelon", label: "Saint Pierre And Miquelon" },
            { value: "Saint Vincent And The Grenadines", label: "Saint Vincent And The Grenadines" },
            { value: "Samoa", label: "Samoa" },
            { value: "San Marino", label: "San Marino" },
            { value: "Sao Tome And Principe", label: "Sao Tome And Principe" },
            { value: "Saudi Arabia", label: "Saudi Arabia" },
            { value: "Senegal", label: "Senegal" },
            { value: "Serbia And Montenegro", label: "Serbia And Montenegro" },
            { value: "Seychelles", label: "Seychelles" },
            { value: "Sierra Leone", label: "Sierra Leone" },
            { value: "Singapore", label: "Singapore" },
            { value: "Slovakia", label: "Slovakia" },
            { value: "Slovenia", label: "Slovenia" },
            { value: "Solomon Islands", label: "Solomon Islands" },
            { value: "Somalia", label: "Somalia" },
            { value: "South Africa", label: "South Africa" },
            { value: "South Georgia And The South Sandwich Islands", label: "South Georgia And The South Sandwich Islands" },
            { value: "Spain", label: "Spain" },
            { value: "Sri Lanka", label: "Sri Lanka" },
            { value: "Sudan", label: "Sudan" },
            { value: "Suriname", label: "Suriname" },
            { value: "Svalbard And Jan Mayen", label: "Svalbard And Jan Mayen" },
            { value: "Swaziland", label: "Swaziland" },
            { value: "Sweden", label: "Sweden" },
            { value: "Switzerland", label: "Switzerland" },
            { value: "Syrian Arab Republic", label: "Syrian Arab Republic" },
            { value: "Taiwan, Province Of China", label: "Taiwan, Province Of China" },
            { value: "Tajikistan", label: "Tajikistan" },
            { value: "Tanzania, United Republic Of", label: "Tanzania, United Republic Of" },
            { value: "Thailand", label: "Thailand" },
            { value: "Timor-Leste", label: "Timor-Leste" },
            { value: "Togo", label: "Togo" },
            { value: "Tokelau", label: "Tokelau" },
            { value: "Tonga", label: "Tonga" },
            { value: "Trinidad And Tobago", label: "Trinidad And Tobago" },
            { value: "Tunisia", label: "Tunisia" },
            { value: "Turkey", label: "Turkey" },
            { value: "Turkmenistan", label: "Turkmenistan" },
            { value: "Turks And Caicos Islands", label: "Turks And Caicos Islands" },
            { value: "Tuvalu", label: "Tuvalu" },
            { value: "Uganda", label: "Uganda" },
            { value: "Ukraine", label: "Ukraine" },
            { value: "United Kingdom", label: "United Kingdom" },
            { value: "United Arab Emirates", label: "United Arab Emirates" },
            { value: "United States", label: "United States" },
            { value: "United States Minor Outlying Islands", label: "United States Minor Outlying Islands" },
            { value: "Uruguay", label: "Uruguay" },
            { value: "Uzbekistan", label: "Uzbekistan" },
            { value: "Vanuatu", label: "Vanuatu" },
            { value: "Venezuela", label: "Venezuela" },
            { value: "Viet Nam", label: "Viet Nam" },
            { value: "Virgin Islands, British", label: "Virgin Islands, British" },
            { value: "Virgin Islands, U.S.", label: "Virgin Islands, U.S." },
            { value: "Wallis And Futuna", label: "Wallis And Futuna" },
            { value: "Western Sahara", label: "Western Sahara" },
            { value: "Yemen", label: "Yemen" },
            { value: "Zambia", label: "Zambia" },
            { value: "Zimbabwe", label: "Zimbabwe" },
        ]
    },
    {
        "id": "residentialStatus",
        "value": [
            { value: "Living with Parents", label: "Living with Parents" },
            { value: "Owner Occupied", label: "Owner Occupied" },
            { value: "Student", label: "Student" },
            { value: "Tennant", label: "Tennant" },
        ]
    },
    {
        "id": "proofOfAddress",
        "value": [
            { value: "Build Soc / Credit Un. Letter", label: "Build Soc/Credit Un. Letter" },
            { value: "Credit Card Statement", label: "Credit Card Statement" },
            { value: "Credit Union Statement", label: "Credit Union Statement" },
            { value: "Electricity supply bill", label: "Electricity Supply Bill" },
            { value: "Income Tax Certificate", label: "Income Tax Certificate" },
            { value: "Land line operators bill", label: "Land Line Operators Bill" },
            { value: "Letter from Bank", label: "Letter from Bank" },
            { value: "Mobile Phone Bill", label: "Mobile Phone Bill" },
            { value: "Motor Insurance", label: "Motor Insurance" },
            { value: "Motor Tax Certificate", label: "Motor Tax Certificate" },
            { value: "Statement from Bank", label: "Statement from Bank" },
            { value: "TV Bill", label: "TV Bill" },
        ]
    },
    {
        "id": "timeAtAddress",
        "value": [
            { value: "0-6 Months", label: "0-6 Months" },
            { value: "7-12 Months", label: "7-12 Months" },
            { value: "12-36 Months", label: "12-36 Months" },
            { value: "36+ Months", label: "36+ Months" },
        ]
    },
    {
        "id": "idType",
        "value": [
            { value: "National Identity Card for EU Nationals", label: "EU National Identity Card" },
            { value: "Foreign Passport", label: "Foreign Passport" },
            { value: "Irish Driving Licence", label: "Irish Driving Licence" },
            { value: "Irish Passport", label: "Irish Passport" },
        ]
    },
    {
        "id": "occupationStatus",
        "value": [
            { value: "Currently Seeking Work", label: "Currently Seeking Work" },
            { value: "Full Time", label: "Full Time" },
            { value: "Homemaker", label: "Homemaker" },
            { value: "Part Time", label: "Part Time" },
            { value: "Retired", label: "Retired" },
            { value: "Self Employed", label: "Self Employed" },
            { value: "Student", label: "Student" },
            { value: "Temporary", label: "Temporary" },
        ]
    },
    {
        "id": "occupationType",
        "value": [
            { value: "Clerical Worker", label: "Clerical Worker" },
            { value: "Currently Seeking Work", label: "Currently Seeking Work" },
            { value: "Director/Higher Management", label: "Director/Higher Management" },
            { value: "Farmer", label: "Farmer" },
            { value: "Homemaker", label: "Homemaker" },
            { value: "Manual Worker", label: "Manual Worker" },
            { value: "Middle Management", label: "Middle Management" },
            { value: "Other", label: "Other" },
            { value: "Public Sector Worker", label: "Public Sector Worker" },
            { value: "Qualified Professional", label: "Qualified Professional" },
            { value: "Retired", label: "Retired" },
            { value: "Skilled Worker", label: "Skilled Worker" },
            { value: "Student 3rd Level", label: "Student 3rd Level" },
            { value: "Supervisory Worker", label: "Supervisory Worker" },
        ]
    },
    {
        "id": "timeEmployer",
        "value": [
            { value: "0-6 months", label: "0-6 months" },
            { value: "6-12 months", label: "6-12 months" },
            { value: "12-36 months", label: "12-36 months" },
            { value: "36+ months", label: "36+ months" },
        ]
    },
    {
        "id": "provider",
        "value": [
            { value: "DIGIWEB", label: "DIGIWEB" },
            { value: "HIVE", label: "HIVE" },
            { value: "HOMEVISION", label: "HOMEVISION" },
            { value: "IFA", label: "IFA" },
            { value: "IMAGINE_(GAELIC)", label: "IMAGINE_(GAELIC)" },
            { value: "MAGNET", label: "MAGNET" },
            { value: "OTHER", label: "OTHER" },
            { value: "PURE", label: "PURE" },
            { value: "SKY", label: "SKY" },
            { value: "SMART", label: "SMART" },
            { value: "VIRGIN MEDIA", label: "VIRGIN MEDIA" },
            { value: "VODAFONE", label: "VODAFONE" },
        ]
    },
    {
        "id": "installationTime",
        "value": [
            { value: "Morning", label: "Morning (9.00 am to 12.30 pm)" },
            { value: "Afternoon", label: "Afternoon (12.30 pm to 4.00 pm)" },
        ]
    },
    {
        "id": "timeAtBank",
        "value": [
            { value: "<1", label: "Under 1 year" },
            { value: "1", label: "1 year" },
            { value: "2", label: "2 years" },
            { value: "3", label: "3 years" },
            { value: "4", label: "4 years" },
            { value: "5", label: "5 years" },
            { value: ">5", label: "Over 5 years" },
        ]
    },
    {
        "id": "mobileNetworkProvider",
        "value": [
            { value: "eirMobile", label: "eir Mobile" },
            { value: "IDMobile", label: "ID Mobile" },
            { value: "Postfone", label: "Postfone" },
            { value: "Tesco", label: "Tesco Mobile" },
            { value: "Three", label: "Three" },
            { value: "Vodafone", label: "Vodafone" },
            { value: "Virgin", label: "Virgin Media" },

        ]
    },
    {
        "id": "prefixProvider",
        "value": [
            { value: "083", label: "083" },
            { value: "085", label: "085" },
            { value: "086", label: "086" },
            { value: "087", label: "087" },
            { value: "088", label: "088" },
            { value: "089", label: "089" },

        ]
    },
];